import { memo } from 'react'
import parse from 'html-react-parser'

import Modal from '../ui/modal/modal'
import Flex from '../ui/flex/flex'
import Button from '../ui/button/button'
import Grid from '../ui/grid/grid'


/** Свойства окна подтверждения действия */
export interface IModalConfirm {
    isOpen: boolean
    
    headerText?: string
    contentText?: string

    handlerButtonCancel?: () => void
    handlerButtonOk?: () => void
}


/** Окно подтверждения действия */
export const ModalConfirm = memo(({isOpen, headerText, contentText, handlerButtonCancel, handlerButtonOk}: IModalConfirm) => {
    return <Modal isOpen={isOpen} isEsc isWrapper onCancel={handlerButtonOk}>
        <Flex className='modal_container'>
            <Flex className='modal_container-header'>
                <h4>{headerText || 'Подтверждение действия...'}</h4>
            </Flex>

            <Flex gap='4px' className='modal_container-body'>
                <Flex className='modal_container-content'>
                    <span style={{fontSize: '15px', letterSpacing: '1.5px', lineHeight: '140%'}}>
                        {parse(contentText || 'Привет:<br/>Вы не указали текст!')}
                    </span>
                </Flex>

                <Grid gap='6px' gridTemplate='columns' gridTemplateColumns='1fr'>
                    {/* <Button variant='primaryDark' width='100%' onClick={handlerButtonCancel}>ОТМЕНА</Button> */}
                    <Button width='100%' onClick={handlerButtonOk}>ЗАКРЫТЬ</Button>
                </Grid>
            </Flex>
        </Flex>
    </Modal>
})